import angular from 'angular';

angular
  .module('cxSettings')
  .controller('ReminderSettingsCtrl', [
    'templateHttpSvc',
    'reminderHttpSvc',
    'dialogsSvc',
    'flySvc',
    'dataCache',
    'reminders',
    'translateListFilter',
    reminderSettingsCtrl,
  ]);

function reminderSettingsCtrl(
  templateHttpSvc,
  reminderHttpSvc,
  dialogsSvc,
  flySvc,
  dataCache,
  reminders,
  translateListFilter,
) {
  var vm = this;
  vm.company = dataCache.getArray('defaultcompany');
  vm.reminders = angular.copy(reminders);
  vm.templates = {};
  templateHttpSvc.getTemplates().then(function(templates) {
    vm.templates = templates
      .filter(x => x.context === 1)
      .map(x => ({ id: x.id, name: translateListFilter(x.id, 'template', x.name) }))
      .sort(function(a, b) {
        return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
      })
      .reduce(function(o, e) {
        o[e.id] = e.name;
        return o;
      }, {});
  });
  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };
  var clean = function(reminder) {
    return {
      id: reminder.id,
      companyId: reminder.companyId,
      template: reminder.template,
      dueDateOffsetDays: reminder.dueDateOffsetDays,
      frequencyDays: reminder.frequencyDays,
      enabled: reminder.enabled,
    };
  };

  vm.save = function(reminder) {
    if (!reminder || !reminder.id) return;
    reminderHttpSvc.updateReminder(clean(reminder)).then(function() {
      if (reminder.original) delete reminder.original;
      reminder.form.$setPristine();
      vm.editing = null;
    }, showError);
  };
  vm.saveNew = function() {
    if (!vm.newReminder) return;
    reminderHttpSvc.createReminder(clean(vm.newReminder)).then(function(reminder) {
      vm.reminders.push(reminder);
      vm.newReminder = null;
      vm.newReminderForm.$setPristine();
    }, showError);
  };
  vm.remove = function(reminder) {
    if (!reminder || !reminder.id) return;
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteReminder').then(function() {
      reminderHttpSvc.removeReminder(reminder.id).then(function() {
        var idx = vm.reminders.indexOf(reminder);
        if (idx >= 0) vm.reminders.splice(idx, 1);
      }, showError);
    });
  };
  vm.edit = function(reminder) {
    vm.editing = reminder.id;
    reminder.original = angular.copy(reminder);
  };

  vm.cancel = function(reminder) {
    if (reminder.original) angular.copy(reminder.original, reminder);
    vm.editing = null;
  };

  vm.add = function() {
    vm.newReminder = {
      companyId: vm.company.id,
      template: null,
      dueDateOffsetDays: 0,
      frequencyDays: 0,
      enabled: true,
      isNew: true,
    };
  };
}
